import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgHandHeldWriting, SvgInstagram, SvgPlaylist } from '@common/icon';
export const BusinessInfo = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="pb-8 font-700 text-Gray-600 typo-body4">주식회사 웰로</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li>대표 : 김유리안나</li>;
    t2 = <li className="pointer-events-none">사업자등록번호 : 705-86-02126</li>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li>통신판매업신고번호 <a className="underline" href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7058602126" target="_blank" rel="noreferrer external">제2024-세종아름-0756호</a></li>;
    t4 = <li><address className="not-italic">서울오피스: 서울특별시 영등포구 여의대로 108, 4층</address></li>;
    t5 = <li><address className="not-italic">세종오피스: 세종특별자치시 가름로 232, 세종비지니스센터</address></li>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ul className="flex flex-col gap-4 pb-8 font-400 text-Gray-600 typo-body4">{t1}{t2}{t3}{t4}{t5}<li className="flex items-center gap-8"><a className="underline" href="mailto:cs@wello.info">cs@wello.info</a><div className="h-10 w-1 bg-Gray-300" /><a href="tel:1833-9363">1833-9363</a></li><li className="pointer-events-none">제호: 웰로</li><li className="pointer-events-none">인터넷신문 등록번호: 세종 아00182 (등록일 2026.04.23)</li><li className="pointer-events-none">발행인: 김유리안나 | 편집인: 신아론 | 청소년보호책임자: 신아론</li></ul>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li><Button theme="sub-line" dimensions="H26" asChild={true} className="bg-Gray-white"><a aria-label={"\uC778\uC2A4\uD0C0\uADF8\uB7A8\uC5D0\uC11C \uC6F0\uB85C \uD314\uB85C\uC6B0\uD558\uAE30"} href="https://www.instagram.com/wello.info" rel="noreferrer" target="_blank" className="flex gap-4 text-Gray-black">인스타그램<SvgInstagram className="size-10 text-Gray-black" /></a></Button></li>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li><Button theme="sub-line" dimensions="H26" asChild={true} className="bg-Gray-white"><a aria-label={"\uC720\uD29C\uBE0C\uC5D0\uC11C \uC6F0\uB85C \uAD6C\uB3C5\uD558\uAE30"} href="https://www.youtube.com/@wello_info" rel="noreferrer" target="_blank" className="flex gap-4 text-Gray-black">유튜브<SvgPlaylist className="size-10 text-Gray-black" /></a></Button></li>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex flex-col">{t0}{t6}<ul className="flex items-center gap-4">{t7}{t8}<li><Button theme="sub-line" dimensions="H26" asChild={true} className="bg-Gray-white"><a aria-label={"\uB124\uC774\uBC84 \uBE14\uB85C\uADF8\uC5D0\uC11C \uC6F0\uB85C \uBC29\uBB38\uD558\uAE30"} href="https://blog.naver.com/wello_official" rel="noreferrer" target="_blank" className="flex gap-4 text-Gray-black">블로그<SvgHandHeldWriting className="size-10 text-Gray-black" /></a></Button></li></ul></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};